import axios from '../axiosHelper';
import Cookies from "js-cookie"

export default {
    state: {
        status: '',
        status_code: '',
        message: '',
        message_code: '',
        silabus : {}
    },
    getters: {
        getSilabus: state => state.silabus,
    },
    mutations: {
        request(state){
            state.status = 'LOADING'
        },
        success(state, { resp }){
            state.status = 'SUCCESS'
            if (resp) {
                state.status_code = resp.data.status
                state.message = resp.data.message
                state.message_code = resp.data.code
            }
        },
        error(state, { resp }){
            state.status = 'ERROR'
            if (resp) {
                state.status_code = resp.data.status
                state.message = resp.data.message
                state.message_code = resp.data.code
            }
        },
        setSilabus(state, { resp }){
            if (resp) {
                state.silabus = resp.data.data
            }
        },
    },
    actions: {
        getSilabus({commit}, param){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v1/syllabus/'+param.subjectId+'?token='+Cookies.get("token"),
                        method: 'GET'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        commit('setSilabus', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
        editSilabus({commit}, form){
            return new Promise(function (resolve, reject) {
                commit('request');
                axios({
                        url: '/v1/syllabus/edit?token='+Cookies.get("token"),
                        data: form,
                        method: 'POST'
                    })
                    .then(resp => {
                        commit('success', { resp })
                        resolve(resp)
                    })
                    .catch(err => {
                        let resp = err.response
                        commit('error', { resp })
                        reject(err)
                    })
            })
        },
    }
}
